import Slider from 'react-slick';

const CommonSlider = ({className,settings, data, RenderCard }) => {
  return (
    <Slider {...settings} className={className}>
      {data.map((item, index) => (
        <div key={index}>
          <RenderCard item={item} dataLength={data.length}></RenderCard>
        </div>
      ))}
    </Slider>
  );
};

export default CommonSlider;
